export default __webpack_public_path__ + "static/media/logo.a05fe7b9.png";